'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var defaultKeys = ['0', '767', '1023'];

exports.default = function (component) {
  return function (values) {
    return function (_React$Component) {
      _inherits(Media, _React$Component);

      function Media() {
        _classCallCheck(this, Media);

        var _this = _possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).call(this));

        _this.state = {
          width: window.innerWidth
        };
        _this.updateWidth = _this.updateWidth.bind(_this);
        return _this;
      }

      _createClass(Media, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          window.addEventListener('resize', this.updateWidth);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          window.removeEventListener('resize', this.updateWidth);
        }
      }, {
        key: 'updateWidth',
        value: function updateWidth() {
          var _this2 = this;

          clearTimeout(this.timeout);
          this.timeout = setTimeout(function () {
            return _this2.setState({
              width: window.innerWidth
            });
          }, 50);
        }
      }, {
        key: 'getValue',
        value: function getValue() {
          var width = this.state.width;
          var realValues = values(this.props);

          if (Array.isArray(realValues)) {
            realValues = realValues.reduce(function (acc, value, index) {
              return _extends({}, acc, _defineProperty({}, defaultKeys[index], value));
            }, {});
          }

          var numbers = Object.keys(realValues).map(function (value) {
            return parseInt(value, 10);
          });
          return realValues[Math.max.apply(null, numbers.filter(function (v) {
            return v <= width;
          }))];
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(component, _extends({}, this.props, {
            media: this.getValue()
          }));
        }
      }]);

      return Media;
    }(_react2.default.Component);
  };
};